import React from 'react';
import { Link } from '@mui/material';
import MfAlert from '../UI/Alert/MfAlert';

const StatisticsAlert = () => (
  <MfAlert severity="info" sx={{ mt: 3 }}>
    <div>
      Обращаем ваше внимание, что статистика отражена только по отправленным из
      личного кабинета заявкам.
    </div>
    <div>
      Мы работаем над отображением статистики по реферальным ссылкам, в данный
      момент уточнить статусы заявок по ним вы можете, связавшись с нами:
    </div>
    <div>
      E-mail:{' '}
      <Link href="mailto:hello@moneyfriends.ru">hello@moneyfriends.ru</Link>
    </div>
    Telegram:{' '}
    <Link target="_blank" href="tg://resolve?domain=moneyfriends_admin">
      @moneyfriends_admin
    </Link>
  </MfAlert>
);

export default StatisticsAlert;
